module.exports = __webpack_public_path__ + "media/src/application/media/v2-img-2-8a2e72aa6e18fbd2cae23f4a0eec11c3.png";